import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const AppTable = Loadable(lazy(() => import('./list/AppTable')));
const Edit = Loadable(lazy(() => import('./edit/edit')));
const clienteRoutes = [
  {
    path: '/material/empresa',
    element: <AppTable />,
  },
  {
    path: '/material/empresa/edit/:id',
    element: <Edit consultar={false} editar={true} novo={false} />,
  },
  {
    path: '/material/empresa/consultar/:id',
    element: <Edit consultar={true} editar={false} novo={false} />,
  },
  {
    path: '/material/empresa/novo',
    element: <Edit consultar={false} editar={false} novo={true} />,
  },

];

export default clienteRoutes;
